import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import SimpleHeader from '../../components/layout/SimpleHeader';
import Button from '../../components/Button';
import { Select, Table, TableColumnsType } from 'antd';
import config from '../../lib/config';
import DownloadButton from '../../components/DownloadButton';
import Pagination from '../../components/common/Pagination';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import useAxios from '../../hooks/useAxios';
import {
  IGetExams,
  IGetTestTypes,
  ITestType,
  IGetExamSemesters,
  IExamSemester,
} from '../../models/testCenter.model';
import { getExams, getExamSemesters, getTestTypes } from '../../api/testCenter.api';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import { getCommonCodeLabel } from '../../lib/store';
import { useHistory, useLocation } from 'react-router';
import QueryString from 'qs';
import _ from 'lodash';
import TestExam from '../../components/cbt/test/Exam';
import TestSubject from '../../components/cbt/test/Subject';
import TestQuiz from '../../components/cbt/test/Quiz';
import ExtendButton from '../../components/ExtendButton';
import TestInspection from '../../components/cbt/test/Inspection';
import useAuth from '../../hooks/useAuth';
import exportTable from '../../lib/exportTable';
import moment from 'moment';
import { IGetSemesterMonths } from '../../models/semesters.model';
import { getSemesterMonths } from '../../api/semesters.api';
import { getReverseYears } from '../../lib/util';
import SelectEduStep from '../../components/SelectEduStep';
import Split from 'react-split';
import TableEmpty from '../../components/common/TableEmpty';

const Block = styled.div`
  .close-left {
    transform: translate(-33%);
  }
`;

enum Contents {
  exam,
  subject,
  quiz,
  inspection,
};

const CbtTest = () => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // TE0001 = 시험구분
  const TE0001 = commonCodes.find(item => item.commonCode === 'TE0001')?.detailCode;
  // SY0005 = 연도
  const SY0005 = commonCodes.find(item => item.commonCode === 'SY0005')?.detailCode;
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find((item) => item.commonCode === 'PR0002')?.detailCode;
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { data: res, isLoading, error, execute } = useAxios<IGetTestTypes>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetExams>();
  // for excel download
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetExams>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetSemesterMonths>();
  const { data: semesterRes, isLoading: semesterIsLoading, error: semesterError, execute: semesterExecute } = useAxios<IGetExamSemesters>();

  const [isExtended, setIsExtended] = useState(false);
  const [content, setContent] = useState<Contents>();
  const [pageNo, setPageNo] = useState(1);
  const [param, setParam] = useState<any>();
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [examDiv, setExamDiv] = useState<string>();
  const [examTypeCode, setExamTypeCode] = useState<number>();
  const [year, setYear] = useState<string>();
  const [semesterCode, setSemesterCode] = useState<number>();
  const [monthSeq, setMonthSeq] = useState<number>();
  const [examName, setExamName] = useState('');

  // 선택한 시험지 PK
  const [examCode, setExamCode] = useState<number | undefined>();
  // 선택한 시험지의 공개(publish) 여부
  const [isPublished, setIsPublished] = useState(false);

  const [examSemesterData, setExamSemesterData] = useState<IExamSemester[]>([]);
  const [examSemesterList, setExamSemesterList] = useState<IExamSemester[]>([]);
  const [typeData, setTypeData] = useState<ITestType[]>([]);
  const [typeList, setTypeList] = useState<ITestType[]>([]);
  const [semesterType, setSemesterType] = useState("");

  useEffect(() => {    
    execute(getTestTypes());
    semesterExecute(getExamSemesters());
  }, []);

  useEffect(() => {
    if (res) {
      setTypeData(res.data);
    }
  }, [res]);

  useEffect(() => {
    if (semesterRes) {
      setExamSemesterData(semesterRes.data);
    }
  }, [semesterRes]);

  useEffect(() => {
    if (semesterCode) {
      execute4(getSemesterMonths(String(semesterCode)));
    }
    setMonthSeq(undefined);
  }, [semesterCode]);

  useEffect(() => {
    const _param: any = {
      pageNo,
      perPage: config.smallPageSize,
    };

    if (query.pageNo) {
      _param.pageNo = Number(query.pageNo);
      setPageNo( _param.pageNo);
    }
    if (query.eduStepCode) {
      _param.eduStepCode = String(query.eduStepCode);
      setEduStepCode(_param.eduStepCode);
    }
    if (query.examDiv) {
      const examDiv = String(query.examDiv);
      _param.examDiv = [examDiv];
      setExamDiv(examDiv);
    }
    if (query.examTypeCode) {
      _param.examTypeCode = Number(query.examTypeCode);
      setExamTypeCode(_param.examTypeCode);
    }
    if (query.year) {
      _param.year = String(query.year);
      setYear(_param.year);
    }
    if (query.semesterCode) {
      _param.semesterCode = Number(query.semesterCode);
      setSemesterCode(_param.semesterCode);
    }
    if (query.monthSeq) {
      _param.monthSeq = Number(query.monthSeq);
      setMonthSeq(_param.monthSeq);
    }
    if (query.examName) {
      _param.examName = String(query.examName);
      setExamName(_param.examName);
    }
    if (query.content) {
      _param.content = Number(query.content);
      setContent(_param.content);
    }
    if (query.semesterType) {
      _param.semesterType = String(query.semesterType);
      setSemesterType(_param.semesterType);
    }

    doGetExams(_param);
    setParam(_param);
  }, [location]);

  useEffect(() => {
    if (res3) {
      const data: any = _.cloneDeep(res3.data);
      data.forEach((item: any) => {
        item.examDiv = getCommonCodeLabel('TE0001', item.examDiv, i18n.language);
      });
      exportTable(columns, data, `${t('cbt.test.9')}_(${moment(serverDate).format('YYYYMMDD')})`, t('cbt.test.9'), [15, 30, 10]);  
    }
  }, [res3]);

  const doGetExams = (_param?: any) => {
    execute2(getExams(_param || param || { pageNo: 1, perPage: config.smallPageSize }));
  }

  const onSetTypeList = (value: string) => {
    setExamTypeCode(undefined);
    const list = typeData.filter(item => item.examDiv === value);
    setTypeList(list);
  };

  const onSetSemesterList = (value: string) => {
    setSemesterCode(undefined);
    let list = examSemesterData.filter(item => item.learningYearCode === value);

    if(semesterType) {
      list = list.filter(item => item.semesterType === semesterType);
    }

    setExamSemesterList(list);
  }

  const onSetSemesterListByType = (value: string) => {
    setSemesterCode(undefined);
    let list = examSemesterData.filter(item => item.semesterType === value);

    if(year) {
      list = list.filter(item => item.learningYearCode === year);
    }

    setExamSemesterList(list);
  }

  const onSearch = () => {
    const param: any = { pageNo: 1 };

    if (eduStepCode) param.eduStepCode = eduStepCode;
    if (examDiv) param.examDiv = examDiv;
    if (examTypeCode) param.examTypeCode = examTypeCode;
    if (year) param.year = year;
    if (semesterCode) param.semesterCode = semesterCode;
    if (monthSeq) param.monthSeq = monthSeq;
    if (examName) param.examName = examName;
    if (semesterType) param.semesterType = semesterType;

    history.push(`/cbt/test?${QueryString.stringify(param)}`);
  };

  const onCreateExam = () => {
    setExamCode(undefined);
    onSetContent(Contents.exam);
  };

  const renderContent = () => {
    switch (content) {
      case Contents.exam:
        return (
          <TestExam
            examCode={examCode}
            setExamCode={setExamCode}
            getExamData={doGetExams}
            typeData={typeData}
            examSemesterData={examSemesterData}
            setIsPublished={setIsPublished}
          />
        );
      case Contents.subject:
        return (
          <TestSubject
            examCode={examCode}
            isPublished={isPublished}
          />
        );
      case Contents.quiz:
        return (
          <TestQuiz
            examCode={examCode}
            isPublished={isPublished}
          />
        );
      case Contents.inspection:
        return (
          <TestInspection
            examCode={examCode}
          />
        );
    }
  };

  const onSetContent = (_content: Contents) => {
    const _param = { ...param, content: _content };
    history.push(`/cbt/test?${QueryString.stringify(_param)}`);
  };

  const onExportTable = () => {
    execute3(getExams({ ...param, perPage: 999999999 }));
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('common.placeholder.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: (value) => getCommonCodeLabel('PR0006', value, i18n.language),
    },
    {
      title: t('cbt.test.placeholder3'),
      dataIndex: 'examDiv',
      align: 'center',
      render: (value) => getCommonCodeLabel('TE0001', value, i18n.language),
    },
    {
      title: t('cbt.test.column1'),
      dataIndex: 'examName',
      align: 'center',
    },
    {
      title: t('cbt.test.column2'),
      dataIndex: 'openYn',
      align: 'center',
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <SelectEduStep
                eduStepCode={eduStepCode}
                setEduStepCode={value => {
                  setEduStepCode(value);
                  setExamDiv(undefined);
                  setExamTypeCode(undefined);
                }}
                includeAll
                fullWidth
              />
            </div>
          </li>
          <li>
            <label>{t('cbt.test.placeholder3')}</label>
            <div>
              <Select
                placeholder={t('cbt.test.placeholder3')}
                value={examDiv}
                onChange={(value) => {
                  setExamDiv(value);
                  onSetTypeList(value);
                }}
                disabled={!eduStepCode}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {TE0001?.map(item => {
                  if (!eduStepCode || item.additionInfo1 === eduStepCode || item.additionInfo2 === eduStepCode) {
                    return (
                      <Select.Option
                        key={item.detailCode}
                        value={item.detailCode}
                      >
                        {item.korName}
                      </Select.Option>
                    )  
                  } else {
                    return null;
                  }
                })}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.test.placeholder1')}</label>
            <div>
              <Select
                placeholder={t('cbt.test.placeholder1')}
                value={examTypeCode}
                onChange={(value) => setExamTypeCode(value)}
                disabled={!examDiv || examDiv === 'all'}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {typeList.map(item => (
                  <Select.Option
                    key={item.examTypeCode}
                    value={item.examTypeCode}
                  >
                    {item.examTypeName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.speakTest.column4')}</label>
            <div>
              <Select
                placeholder={t('cbt.speakTest.column4')}
                value={year}
                onChange={value => {
                  setYear(value);
                  onSetSemesterList(value);
                }}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {getReverseYears(SY0005).map(item => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>
              {t('program.semester.column11')}
            </label>
            <Select
              className="w-120p"
              value={semesterType}
              onChange={value => {
                setSemesterType(value);
                onSetSemesterListByType(value);
              }}
            >
              <Select.Option value="">{t('common.text.all')}</Select.Option>
              {
                PR0002?.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>            
          <li>
            <label>{t('common.column.semester')}</label>
            <div>
              <Select
                placeholder={t('common.column.semester')}
                value={semesterCode}
                onChange={value => setSemesterCode(value)}
                disabled={!year}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {examSemesterList.map(item => (
                  <Select.Option
                    key={item.semesterCode}
                    value={item.semesterCode}
                  >
                    {item.semesterName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.test.10')}</label>
            <div>
              <Select
                placeholder={t('cbt.test.10')}
                value={monthSeq}
                onChange={value => setMonthSeq(value)}
                disabled={!semesterCode}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {res4?.data?.map(item => (
                  <Select.Option
                    key={item.monthSeq}
                    value={item.monthSeq}
                  >
                    {item.monthName}{t('payment.charge.text4')}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('cbt.test.column1')}</label>
            <input
              type="text"
              className="form-control w-150p"
              placeholder={t('cbt.test.column1')}
              value={examName}
              onChange={(e) => setExamName(e.target.value)}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>	
    <Block className="content">
      {(isLoading || isLoading2 || isLoading3 || isLoading4 || semesterIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={semesterError} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.test.title1')}
        onlyTitle={true}
      />

      <Split
        className="splite-divide"
        sizes={[30, 70]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className="col-frame left_panel">
          <div className="comm-bx__between">
            <div className="comm-sch_result">{t('common.text.count')}: <b>{res2?.total || 0}</b>{t('common.text.unit')}</div>
            <div></div>
          </div>
          <div className="comm-table__area">
            <Table
              columns={columns}
              dataSource={res2?.data}
              pagination={{
                current: pageNo,
                pageSize: config.smallPageSize,
              }}
              onRow={(record) => {
                return {
                  onClick: () => {
                    setExamCode(record.examCode);
                    if (content === undefined) {
                      setContent(Contents.exam);
                    }
                  },
                };
              }}
              rowClassName={(record: any) =>
                record.examCode === examCode ? 'chosen' : 'pointer'
              }
              rowKey="examCode"
            />
          </div>
          <div className="comm-bx__between">
            <DownloadButton onClick={onExportTable} />
            <div className="common-paging right">
              <Pagination
                page={pageNo}
                total={res2?.total}
                pageSize={10}
                url="/cbt/test"
                small
              />
            </div>
          </div>
        </div>
        <div className="col-frame right_panel">
          <div className='position-relative'>
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink"
                onClick={onCreateExam}
                text={t('cbt.test.button1')}
                writeAuthYn={writeAuthYn}
              />            
            </div>
            <div className="comm-tab__line">
              <ul>
                <li className={(content === Contents.exam ? ' active' : '')}>
                  <a className="btn-item" onClick={() => onSetContent(Contents.exam)}>
                    {t('cbt.test.tab1')}
                  </a>
                </li>
                <li className={(content === Contents.subject ? ' active' : '') + (examCode ? '' : ' disabled')}>
                  <a className="btn-item" onClick={() => onSetContent(Contents.subject)}>
                    {t('cbt.test.tab2')}
                  </a>
                </li>
                <li className={(content === Contents.quiz ? ' active' : '') + (examCode ? '' : ' disabled')}>
                  <a className="btn-item" onClick={() => onSetContent(Contents.quiz)}>
                    {t('cbt.test.tab3')}
                  </a>
                </li>
                <li className={(content === Contents.inspection ? ' active' : '') + (examCode ? '' : ' disabled')}>
                  <a className="btn-item" onClick={() => onSetContent(Contents.inspection)}>
                    {t('cbt.test.tab4')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="tab-content" id="custom-tabs-tabContent">
            {
              content === undefined
                ? <TableEmpty text={t('cbt.test.text1')} />
                : renderContent()
            }
          </div>
        </div>
      </Split>
    </Block>
    </>
  );
};

export default CbtTest;